const modules = import.meta.glob('./*/*.ts', { eager: true });

// resources[lang][namespace] = { key: value } — namespace comes from the
// filename (e.g. local/fr/common.ts → namespace "common"), matching the
// useTranslation('common') calls used throughout the app.
const messages: Record<string, Record<string, Record<string, string>>> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang, namespace] = match;
    const module = modules[path] as { default?: Record<string, string> };

    if (!messages[lang]) {
      messages[lang] = {};
    }

    if (module.default) {
      messages[lang][namespace] = {
        ...messages[lang][namespace],
        ...module.default,
      };
    }
  }
});

export default messages;